import { token } from '@/infrastructure/container';

// Injectable clock so tests can pin time. `Date.now()` in prod, a fake in tests.

export interface IClock {
  nowMs(): number;
  startTicker(everyMs: number, cb: () => void): () => void;
}

export class SystemClock implements IClock {
  nowMs(): number {
    return Date.now();
  }
  startTicker(everyMs: number, cb: () => void): () => void {
    const id = setInterval(cb, everyMs);
    return () => clearInterval(id);
  }
}

export const TOKEN_IClock = token<IClock>('IClock');
